import {memo, type FC} from 'react';
import SectionIcon from '../../../../../../shared/components/SectionIcon';
import TransWithFallback from '../../../../../../shared/components/Translations/TransWrapper';
import { INGAME_CAMPAIGN_TABS } from '@repo/common';

import styles from './IngameNavigationItem.module.css';

interface IngameNavigationItemProps {
    tabName: keyof typeof INGAME_CAMPAIGN_TABS,
    isActive: boolean,
    onClick: (tabName: keyof typeof INGAME_CAMPAIGN_TABS) => void
}

const IngameNavigationItem: FC<IngameNavigationItemProps> = ({ tabName, isActive, onClick }) => {
    const sectionName = INGAME_CAMPAIGN_TABS[tabName];
    const tabLabelKey = `sections.names.${sectionName}`;
    const tabLabelFallback = sectionName.replace(/_/g, ' ');

    return <div
        className={styles.tab}
        data-is-active={isActive}
        onClick={() => onClick(tabName)}
        role="button"
        tabIndex={0}
    >
        <SectionIcon
            sectionName={tabName}
            isActive={isActive}
        />
        <span className={styles.tabLabel}>
            <TransWithFallback
                i18nKey={tabLabelKey}
                components={{ pnl: <br />, nl: <br /> }}
                customFallbackTranslation={tabLabelFallback}
            />
        </span>
    </div>
}

export default memo(IngameNavigationItem);
